module.exports = __webpack_public_path__ + "img/18.e4fe0ea9.jpg";